import React, { useState } from "react";
import { Button, ButtonToolbar, Col, Form, Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { Navigate } from "react-router-dom";

const TabletRegistrationLanding = () => {
  const [deviceId, setDeviceId] = useState("");
  const [doRedirect, setDoRedirect] = useState(false);

  const onChangeDeviceIdInputHandler = (event) => {
    setDeviceId(event.target.value);
  };

  const onSubmitDeviceIdHandler = (event) => {
    event.preventDefault();
    if (deviceId.trim() !== "") {
      setDoRedirect(true);
    }
  };

  if (doRedirect) {
    return <Navigate to={`/tablet-registration/${deviceId}`} />;
  }

  return (
    <Card>
      <Card.Header className="card-header-borderless" as="h3">
        Device uitgeven
      </Card.Header>
      <Card.Body>
        <Form onSubmit={onSubmitDeviceIdHandler}>
          <Row className="align-items-center">
            <Form.Group as={Col} xs="auto" controlId="userSearchFormTitle">
              <Form.Label>CI-nummer:</Form.Label>
            </Form.Group>
            <Form.Group as={Col} xs="auto" controlId="deviceIdInput">
              <Form.Control
                type="text"
                autoComplete="off"
                value={deviceId}
                onChange={onChangeDeviceIdInputHandler}
              />
            </Form.Group>
            <Form.Group as={Col} xs="auto" controlId="formActions">
              <ButtonToolbar>
                <Button type="submit" variant="light">
                  Registreren
                </Button>
              </ButtonToolbar>
            </Form.Group>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default TabletRegistrationLanding;
